import React, { useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import tw from 'twin.macro';
import { AppContext } from '../context';
import { ItemDetailsPage } from '../pages/ItemDetailsPage';
import { TimesIcon } from 'icons';
import { Header } from '../sections';
import { Button } from '../button';
import { ScrollBarContent } from '../scroll';

export const CloseModalButton = ({ topBar = false }) => {
  const { setSlideIn } = useContext(AppContext);
  const [, setSearchParams] = useSearchParams();
  return (
    <>
      <Button
        label='sluiten'
        iconProps={{
          Type: TimesIcon,
        }}
        className={topBar && 'group text-light'}
        css={[
          tw`border-danger`,
          !topBar &&
            tw`fixed bottom-3 pl-3 pr-2 z-50 block xl:hidden flex bg-primary hover:contrast-75 transition-all left-[calc(50% - 56px)]`,
        ]}
        onClick={() => {
          setSearchParams({});
          setSlideIn({
            fullwidth: false,
            active: false,
            Component: () => <></>,
          });
        }}
        ghost={topBar}
      />
    </>
  );
};

export const ItemModal = () => {
  const { windowSize } = useContext(AppContext);

  return (
    <>
      <Header tw='lg:rounded-t-lg' isModal />
      {!['DESKTOP'].includes(windowSize.adBreakPoint) && <CloseModalButton />}
      {/* TODO: ScrollBarContent uses LayoutEffect and renders only on client
          But we need ItemDetailsPage to be rendered on server to set meta tags */}
      <ScrollBarContent tw='mb-4 pr-0'>
        <ItemDetailsPage isModal />
      </ScrollBarContent>
    </>
  );
};
